import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import config from 'shared/config';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import PropTypes from 'prop-types';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { withStyles } from '@material-ui/core/styles';
import PriceFilterContainer from '../containers/PriceFilterContainer';
import styles from '../styles.css';

const muiStyles = theme => ({
	checkboxLabel: {
		fontSize: '1em',
	},

	formControlStyle: {
		height: '2em',
		paddingBottom: '10px',
	},
	button: {
		color: theme.palette.secondary.main,
		backgroundColor: theme.palette.background.paper,
		'&:hover': {
			backgroundColor: theme.palette.grey[100],
		},
	},
});

const Filter = props => {
	const { classes } = props;

	return (
		<div className={styles['filter-aside-container']}>
			<div className={styles['filter-aside-header']}>
				<div className={styles['filter-inline-button']}>
					<Button variant="contained" onClick={props.goResetFilters} className={classes.button}>
						Clear
					</Button>
				</div>
				<div className={styles['filter-inline-button']}>
					<Button variant="contained" onClick={props.toggleDrawer} className={classes.button}>
						Close
					</Button>
				</div>
			</div>
			<Scrollbars style={{ height: '90vh' }}>
				<div className={styles['filter-aside-scroll']}>
					{props.displayMessage ? (
						<div className={styles['filter-message']}>No Products Found</div>
					) : null}
					<FormGroup style={{ paddingTop: '10px' }}>
						{config.PRODUCT.ShowOnDisplay ? (
							<FormControlLabel
								control={
									<Checkbox
										checked={props.onDisplayChecked}
										color="primary"
										onChange={(event, checked) => props.handleValueChange({ onDisplay: checked })}
									/>
								}
								label="On Display Only"
								className={classes.formControlStyle}
								classes={{ label: classes.checkboxLabel }}
							/>
						) : null}
						{config.PRODUCT.ShowInStock ? (
							<FormControlLabel
								control={
									<Checkbox
										checked={props.inStockChecked}
										color="primary"
										onChange={(event, checked) => props.handleValueChange({ inStockOnly: checked })}
									/>
								}
								label="In Stock Only"
								className={classes.formControlStyle}
								classes={{ label: classes.checkboxLabel }}
							/>
						) : null}
					</FormGroup>
					<div className={styles['filter-card']}>
						<PriceFilterContainer handleValueChange={props.handleValueChange} />
					</div>
					{props.buildSpecAttributesTable()}
				</div>
			</Scrollbars>
		</div>
	);
};

Filter.propTypes = {
	classes: PropTypes.shape({
		button: PropTypes.string,
		checkboxLabel: PropTypes.string,
		formControlStyle: PropTypes.string,
	}).isRequired,
	buildSpecAttributesTable: PropTypes.func.isRequired,
	displayMessage: PropTypes.bool.isRequired,
	goResetFilters: PropTypes.func.isRequired,
	handleValueChange: PropTypes.func.isRequired,
	inStockChecked: PropTypes.bool.isRequired,
	onDisplayChecked: PropTypes.bool.isRequired,
	toggleDrawer: PropTypes.func.isRequired,
};

// for testing purposes
export { Filter as FilterClass };
export default withStyles(muiStyles, { name: 'Filter' })(Filter);
